import Dexie from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";

/**
 * Defines the upgrade path for version 16 of indexed DB.
 * Removes the DispatchServiceCapturedBinaryDataFragments table as part of the legacy photo sync cleanup.
 */
export class DatabaseUpgradeV16 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 16;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).stores({
			// Setting to null removes the table
			DispatchServiceCapturedBinaryDataFragments: null
		});
	}
}